module.exports = __webpack_public_path__ + "media/drivier_call.a0309572.mp3";